(function() {
  // ═══════════════════════════════════════════════════
  // CONFIGURATION - Update these URLs when sheets change
  // ═══════════════════════════════════════════════════
  // Each URL is a published Google Sheet tab exported as CSV
  // To get the URL: Google Sheet > File > Share > Publish to web > select tab > CSV
  var MM_CSV_SOURCES = [
    {
      type: 'Drinks',
      url: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQzaXbNv697zTa2YTU8KPkvVga6jyltf2fO4cOE-dz-1ShvveYzwkJwWajQCdd3N1FWPKY-3JARIxln/pub?gid=435945249&single=true&output=csv'
    },
    {
      type: 'Food',
      url: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQzaXbNv697zTa2YTU8KPkvVga6jyltf2fO4cOE-dz-1ShvveYzwkJwWajQCdd3N1FWPKY-3JARIxln/pub?gid=814659632&single=true&output=csv'
    }
  ];
  // ═══════════════════════════════════════════════════

  // Data structure: { "Drinks": { "Cocktails": [{n, t}, ...], "Wine": [...] }, "Food": { "Pizza": [...] } }
  var mmAllData = {};

  // Track current items for each person's search
  var mmCurrentItems = {};

  // Fallback image for missing thumbnails
  var mmFallback = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'%3E%3Crect fill='%23f0f0f0' width='40' height='40'/%3E%3Ctext x='20' y='25' text-anchor='middle' fill='%23999' font-size='10'%3E?%3C/text%3E%3C/svg%3E";

  // Number word to digit mapping
  var numberMap = {
    'one': 1, 'two': 2, 'three': 3, 'four': 4,
    'five': 5, 'six': 6, 'seven': 7, 'eight': 8, 'nine': 9
  };

  // Parse a CSV line (handles quoted fields with commas)
  function parseCSVLine(line) {
    var result = [];
    var current = '';
    var inQuotes = false;
    var i, ch;
    for (i = 0; i < line.length; i++) {
      ch = line[i];
      if (ch === '"') {
        inQuotes = !inQuotes;
      } else if (ch === ',' && !inQuotes) {
        result.push(current);
        current = '';
      } else {
        current += ch;
      }
    }
    result.push(current);
    return result;
  }

  // Fetch a CSV and parse it into categories: { "Category": [{n, t}, ...] }
  // Uses Column B (Sub Category) for grouping. Items with comma-separated
  // sub-categories appear in each category (e.g. "Breakfast, Kids" -> both).
  function fetchCSV(url) {
    return fetch(url)
      .then(function(res) {
        if (!res.ok) throw new Error('Failed to fetch: ' + res.status);
        return res.text();
      })
      .then(function(csvText) {
        var lines = csvText.split('\n');
        var categories = {};
        var i, j, line, cols, subCategory, displayName, thumbnailUrl, subCats, cat;

        // Skip header row (row 0), parse each data row
        for (i = 1; i < lines.length; i++) {
          line = lines[i].trim();
          if (!line) continue;

          cols = parseCSVLine(line);
          if (cols.length < 3) continue;

          // cols[0] = Type (Drinks/Food) - not needed, we know from the source
          subCategory = (cols[1] || '').trim();  // Column B: Sub Category
          displayName = (cols[2] || '').trim();  // Column C: Display Name
          // cols[3] = File Name (not needed on storefront)
          thumbnailUrl = (cols[4] || '').trim(); // Column E: Thumbnail URL

          if (!subCategory || !displayName) continue;

          // Split comma-separated sub-categories (e.g. "Breakfast, Kids")
          subCats = subCategory.split(',');
          for (j = 0; j < subCats.length; j++) {
            cat = subCats[j].trim();
            if (!cat) continue;

            if (!categories[cat]) {
              categories[cat] = [];
            }
            categories[cat].push({ n: displayName, t: mmBetterThumb(thumbnailUrl, displayName) });
          }
        }

        // Sort items within each category alphabetically and remove duplicates
        for (cat in categories) {
          categories[cat].sort(function(a, b) {
            return a.n.localeCompare(b.n);
          });
        }

        return categories;
      });
  }

  // Build a single searchable list across every category for a type (used for "All Drinks").
  function mmGetAllItems(type) {
    var categories = mmAllData[type] || {};
    var seen = {};
    var items = [];
    var cat, list, i, item, key;

    for (cat in categories) {
      list = categories[cat] || [];
      for (i = 0; i < list.length; i++) {
        item = list[i];
        key = (item.n || '').toLowerCase();
        if (!key || seen[key]) continue;
        seen[key] = true;
        items.push(item);
      }
    }

    items.sort(function(a, b) {
      return a.n.localeCompare(b.n);
    });
    return items;
  }

  // Sharper 300px thumbnails: a map from the sheet's thumbnail file name to the new image URL.
  // The map is a theme asset whose URL buy-buttons.liquid supplies; without it the sheet's URLs are used.
  var mmThumbMap = {};

  function loadThumbMap() {
    var url = window.MM_THUMB_MAP_URL;
    if (!url) return Promise.resolve();
    return fetch(url)
      .then(function(res) { return res.ok ? res.json() : {}; })
      .then(function(map) { mmThumbMap = map || {}; })
      .catch(function() { mmThumbMap = {}; });
  }

  // Items that share a thumbnail in the sheet but have their own drawing are mapped by name ("name:Croissant Chocolate").
  function mmBetterThumb(url, name) {
    if (name && mmThumbMap['name:' + name]) return mmThumbMap['name:' + name];
    if (!url) return url;
    var key = url.split('/files/').pop().split('?')[0];
    return mmThumbMap[key] || url;
  }

  // Ask Shopify's image CDN for a smaller copy, so the list loads quickly and only
  // the watermarked preview ever shows a drawing at full size.
  function mmSized(url, width) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  // Load all data from Google Sheets
  function loadAllData() {
    return loadThumbMap().then(loadSheets);
  }

  function loadSheets() {
    var promises = [];
    var i, source;

    for (i = 0; i < MM_CSV_SOURCES.length; i++) {
      source = MM_CSV_SOURCES[i];
      // Skip sources with placeholder URLs
      if (!source.url || source.url.indexOf('URL_HERE') !== -1) {
        continue;
      }
      promises.push(
        fetchCSV(source.url).then((function(type) {
          return function(categories) {
            mmAllData[type] = categories;
          };
        })(source.type))
      );
    }

    if (promises.length === 0) {
      return Promise.reject(new Error('No valid CSV sources configured'));
    }

    return Promise.all(promises);
  }

  // Check if this is a valid drink/food customization product
  // Reads mm-enabled data attribute set by Liquid (from metafields or auto-detection)
  function isDrinkProduct() {
    var el = document.getElementById('mm-product-handle');
    if (!el) return false;

    // Wedding Present (Champagne only): the product options app already asks for the person on
    // the left and right, and there is no food or drink to choose, so this form would ask twice.
    // Maisie's order app reads those names for this product (V2 2.0.9).
    if (/champagne/.test((el.dataset.handle || '').toLowerCase())) return false;

    // Primary: Liquid sets this from metafields or handle/collection auto-detection
    var mmEnabled = el.dataset.mmEnabled;
    if (mmEnabled === 'true') return true;
    if (mmEnabled === 'false') return false;

    // Final fallback: handle-based detection (safety net if Liquid didn't set it)
    var h = (el.dataset.handle || '').toLowerCase();
    if (h.match(/drinks?-for-/i)) return true;
    if (h.match(/munch-for-/i)) return true;
    if (h.indexOf('valentines') !== -1) return true;
    if (h.indexOf('valentine') !== -1) return true;
    if (h.indexOf('wedding') !== -1) return true;
    if (h.indexOf('letters-from-us') !== -1) return true;
    if (h.indexOf('letter-from-us') !== -1) return true;
    if (h.indexOf('personalit') !== -1) return true;

    return false;
  }

  // Get number of people from product config
  // Priority: product metafield mm.person_count > fallback to handle parsing
  function getPersonCount() {
    var el = document.getElementById('mm-product-handle');
    if (!el) return 2;

    // Check metafield first
    var mmCount = el.dataset.mmPersonCount;
    if (mmCount) {
      var n = parseInt(mmCount);
      if (!isNaN(n) && n >= 1 && n <= 9) return n;
    }

    // Fallback: handle-based detection
    var h = (el.dataset.handle || '').toLowerCase();

    if (h.indexOf('valentines') !== -1) return 2;
    if (h.indexOf('letters-from-us') !== -1) return 2;
    if (h.indexOf('letter-from-us') !== -1) return 2;
    if (h.indexOf('wedding') !== -1) return 2;

    // "one-personality", "two-personalities" ... "eight-personalities"
    var pMatch = h.match(/^(\w+)-personalit/i);
    if (pMatch && numberMap[pMatch[1].toLowerCase()]) {
      return numberMap[pMatch[1].toLowerCase()];
    }

    var match = h.match(/(?:drinks?|munch)-for-(\w+)/i);
    if (match) {
      var word = match[1].toLowerCase();
      if (numberMap[word]) return numberMap[word];
      var num = parseInt(word);
      if (!isNaN(num) && num >= 1 && num <= 9) return num;
    }
    return 2;
  }

  // Check whether to show the Drawing Title field
  // Priority: product metafield mm.show_title > fallback handle-based > default true
  function shouldShowTitle() {
    var el = document.getElementById('mm-product-handle');
    if (!el) return true;

    // Check metafield first
    var mmShowTitle = el.dataset.mmShowTitle;
    if (mmShowTitle === 'false') return false;
    if (mmShowTitle === 'true') return true;

    // Default: show title
    return true;
  }

  // Which form variant to render: '' (standard) or 'personalities'
  // Priority: product metafield munch.mode > handle contains 'personalit'
  function getMode() {
    var el = document.getElementById('mm-product-handle');
    if (!el) return '';

    var mode = (el.dataset.mmMode || '').toLowerCase();
    if (mode) return mode;

    var h = (el.dataset.handle || '').toLowerCase();
    if (h.indexOf('personalit') !== -1) return 'personalities';

    return '';
  }

  // Word for each count, used in the personalities caption
  var countWords = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE'];

  // Turn a typed owner name into a possessive, respecting what the customer typed.
  // "Ben" -> "BEN'S", "James" -> "JAMES'S", "James'" -> "JAMES'" (left alone),
  // "Jess's" -> "JESS'S" (left alone). Blank -> "MY".
  function mmPossessive(raw) {
    var name = (raw || '').replace(/\s+/g, ' ').trim();
    if (!name) return 'MY';

    var upper = name.toUpperCase();
    // Already possessive (ends in an apostrophe, or apostrophe + S)? Leave it.
    if (/[\u2019']S?$/.test(upper)) return upper;

    return upper + '\u2019S';
  }

  // Build the full caption, e.g. "BEN'S TWO PERSONALITIES" or "MY PERSONALITY"
  function mmBuildCaption(rawOwner, personCount) {
    var owner = mmPossessive(rawOwner);
    if (personCount === 1) return owner + ' PERSONALITY';

    var word = countWords[personCount] || String(personCount);
    return owner + ' ' + word + ' PERSONALITIES';
  }

  // Keep the caption preview and the submitted property in sync
  window.mmUpdateCaption = function() {
    var input = document.getElementById('mm-owner');
    var hidden = document.getElementById('mm-owner-caption');
    var preview = document.getElementById('mm-owner-preview');
    if (!input || !hidden) return;

    var caption = mmBuildCaption(input.value, getPersonCount());
    hidden.value = caption;
    if (preview) {
      preview.textContent = 'Your drawing will say: ' + caption;
    }
  };

  // Property prefix for a person/personality: "Person 1" or "Personality 1"
  function mmPropPrefix(num) {
    return (getMode() === 'personalities' ? 'Personality ' : 'Person ') + num;
  }

  // ═══════════════════════════════════════════════════
  // CREATE YOUR MUNCH: one search box per person (18 Oct 2026)
  // Replaces the old Food or Drink, Category and Your choice drop-downs. The order still gets
  // exactly the same fields: "Person N Name", "Person N Drink" or "Person N Food" (or
  // "Personality N ..."), "Drawing Title" and "Holding Hands", so Maisie's order app is unchanged.
  // ═══════════════════════════════════════════════════

  // Words that also find a category, so "crisps" brings up the savoury snacks and "coffee" the
  // barista drinks, even when the drawing's own name is a brand.
  var MM_CAT_WORDS = {
    'Savoury Snacks': 'crisps snacks nibbles', 'Barista': 'coffee tea hot drink cafe', 'Beer & Cider': 'beer cider lager ale pint',
    'Spirits & Mixers': 'spirit gin vodka rum whisky whiskey mixer', 'Wine': 'wine fizz bubbles', 'Sweet Treats': 'sweets chocolate biscuit dessert pudding',
    'Soft Drinks': 'soft drink fizzy juice pop', 'Cocktails': 'cocktail', 'Takeaway & Home Cooked': 'takeaway dinner meal',
    'Fruit & Veg': 'fruit veg vegetable', 'Bakery & Puddings': 'bakery bread cake pudding', 'Condiments & Spreads': 'sauce condiment spread',
    'Breakfast': 'breakfast brunch', 'Deli': 'deli cheese charcuterie', 'Butcher & Fishmonger': 'meat fish seafood', 'Kids': 'kids children'
  };
  var MM_SHOW = 80;   // results drawn at once; typing more narrows them
  var mmIndex = null; // { list: [{n, t, k, c, nameKey, key}], byName: {} }
  var mmHands = {};   // pair number -> true when those two neighbours hold hands
  var mmNamesOff = false;   // customer chose a drawing with no names under it (Maisie, 29 Oct 2026)

  // Same matching rules as Maisie's trade show iPad: accents ignored, "G&T" also means gin and
  // tonic, "&" and "and" are the same word, and each word must start a word in the drawing's name,
  // categories or category words.
  function mmFold(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, ''); }
  function mmSearchable(s) { return ' ' + mmFold(s).replace(/\bg\s*&\s*t\b/g, ' g&t gin tonic ').replace(/&/g, ' and ').replace(/[^a-z0-9&]+/g, ' ') + ' '; }
  function mmWords(q) { return mmSearchable(q).trim().split(/\s+/).filter(function(w) { return w && w !== 'and'; }); }

  function mmBuildIndex() {
    var byName = {};
    var list = [];
    var type, cat, items, i, it, key, entry;
    for (type in mmAllData) {
      for (cat in mmAllData[type]) {
        items = mmAllData[type][cat];
        for (i = 0; i < items.length; i++) {
          it = items[i];
          key = it.n.toLowerCase();
          entry = byName[key];
          if (!entry) {
            entry = byName[key] = { n: it.n, t: it.t, k: type, c: [] };
            list.push(entry);
          }
          if (entry.c.indexOf(cat) === -1) entry.c.push(cat);
        }
      }
    }
    list.sort(function(a, b) { return a.n.localeCompare(b.n, 'en-GB'); });
    for (i = 0; i < list.length; i++) {
      it = list[i];
      it.nameKey = mmSearchable(it.n);
      it.key = mmSearchable(it.n + ' ' + it.c.join(' ') + ' ' + it.c.map(function(c) { return MM_CAT_WORDS[c] || ''; }).join(' ') + ' ' + it.k);
    }
    mmIndex = { list: list, byName: byName };
  }

  function mmSearch(q) {
    var w = mmWords(q);
    if (!w.length) return [];
    var hits = mmIndex.list.filter(function(it) {
      return w.every(function(x) { return it.key.indexOf(' ' + x) !== -1; });
    });
    function score(it) {
      var s = 0;
      w.forEach(function(x) { if (it.nameKey.indexOf(' ' + x) !== -1) s += 2; });
      if (it.nameKey.indexOf(' ' + w[0]) === 0) s += 1;
      return -s;
    }
    hits.sort(function(a, b) { return score(a) - score(b) || a.n.localeCompare(b.n, 'en-GB'); });
    return hits;
  }

  function mmEsc(s) {
    return String(s).replace(/[&<>"']/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function mmChoiceOptionalHere() {
    var el = document.getElementById('mm-product-handle');
    return /champagne/.test(((el && el.dataset.handle) || '').toLowerCase());
  }

  var mmSearchIcon = '<svg class="mm-pick-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>';

  // Generate HTML for a person section
  function generatePersonHTML(num) {
    var isPersonalities = getMode() === 'personalities';
    var heading = (isPersonalities ? 'Personality ' : 'Person ') + num;
    var prefix = mmPropPrefix(num);
    var optional = mmChoiceOptionalHere();
    var total = mmIndex ? mmIndex.list.length : 0;

    // Personalities drawings carry no names, so the name box is dropped entirely
    var nameField = isPersonalities ? '' :
      '<div class="mm-field mm-field--name">' +
        '<label class="mm-label" for="mm-name-' + num + '">Name</label>' +
        '<input type="text" class="mm-input" id="mm-name-' + num + '" name="properties[Person ' + num + ' Name]" placeholder="Name, as it should appear" maxlength="40" autocomplete="off">' +
      '</div>';

    // Up and down swap this person (name and drawing) with a neighbour (Noah, 18 Oct)
    var count = getPersonCount();
    var arrow = function(dir, d, label, disabled) {
      return '<button type="button" class="mm-move-btn" data-num="' + num + '" data-dir="' + dir + '" aria-label="' + label + '"' + (disabled ? ' disabled' : '') + '>' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg></button>';
    };
    var moves = count > 1 ? '<div class="mm-move">' +
      arrow(-1, 'M6 15l6-6 6 6', 'Move ' + heading + ' up', num === 1) +
      arrow(1, 'M6 9l6 6 6-6', 'Move ' + heading + ' down', num === count) + '</div>' : '';

    return '<div class="mm-person" data-num="' + num + '">' +
      '<div class="mm-person-header">' +
        '<div class="mm-person-number">' + num + '</div>' +
        '<div class="mm-person-title">' + heading + '</div>' +
        moves +
      '</div>' +
      '<div class="mm-person-fields' + (isPersonalities ? ' mm-person-fields--single' : '') + '">' +
        nameField +
        '<div class="mm-field mm-field--fav">' +
          '<label class="mm-label" for="mm-q-' + num + '">Favourite food or drink' + (optional ? ' <span class="mm-optional">(optional)</span>' : '') + '</label>' +
          '<div class="mm-pick" id="mm-pick-' + num + '">' +
            '<div class="mm-pick-box" id="mm-pick-box-' + num + '">' + mmSearchIcon +
              '<input type="text" class="mm-input mm-pick-input" id="mm-q-' + num + '" data-num="' + num + '" data-mm-first-choice ' +
                'placeholder="Search ' + total + ' drawings, e.g. Negroni" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" ' +
                'role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="mm-dropdown-' + num + '">' +
              '<div class="mm-dropdown mm-results" id="mm-dropdown-' + num + '" role="listbox"></div>' +
            '</div>' +
            '<input type="hidden" id="mm-drink-value-' + num + '" name="properties[' + prefix + ' Choice]">' +
            '<div class="mm-selected" id="mm-selected-' + num + '">' +
              '<img id="mm-selected-img-' + num + '" src="" alt="">' +
              '<div class="mm-selected-info">' +
                '<div class="mm-selected-label">Selected:</div>' +
                '<div class="mm-selected-name" id="mm-selected-name-' + num + '"></div>' +
              '</div>' +
              '<button type="button" class="mm-change" data-num="' + num + '">Change</button>' +
            '</div>' +
            '<div class="mm-browse" id="mm-browse-' + num + '">Not sure? <button type="button" class="mm-browse-btn" data-num="' + num + '" aria-expanded="false">Browse the menu</button></div>' +
            '<div class="mm-chips" id="mm-chips-' + num + '"></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // ---- Holding hands ----
  // Characters are drawn left to right in Person order, so only neighbours can hold hands.
  // Munch for Two to Nine (and their E-Prints) only: the wedding, engagement, Valentine's and
  // Letters from Us products already show the couple holding hands.
  function mmHandsEnabled(personCount) {
    var el = document.getElementById('mm-product-handle');
    var h = ((el && el.dataset.handle) || '').toLowerCase();
    if (personCount < 2 || getMode() === 'personalities') return false;
    if (/letters?-from-us|wedding|valentine|engagement|personalit/.test(h)) return false;
    return /(?:drinks?|munch)-for-(?:two|three|four|five|six|seven|eight|nine)(?:-|$)/.test(h);
  }

  // "Names on the drawing" switch, under the people: on by default. Off sends "Names on Drawing: No"
  // (only then, so every other order is unchanged; her order app shows it) and makes names optional.
  // Munch for One to Nine only: the couple products and Personalities are left as they are.
  function mmNamesToggleEnabled() {
    // Switched off 3 Nov 2026 (Maisie): the switch kept ending up off on real orders, so names stopped reaching
    // her order app. Names are always asked for again; the switch code stays for later.
    return false;
    var el = document.getElementById('mm-product-handle');
    var h = ((el && el.dataset.handle) || '').toLowerCase();
    if (getMode() === 'personalities') return false;
    if (/letters?-from-us|wedding|valentine|engagement|personalit/.test(h)) return false;
    return /(?:drinks?|munch)-for-(?:one|two|three|four|five|six|seven|eight|nine)(?:-|$)/.test(h);
  }

  function generateNamesToggleHTML() {
    return '<div class="mm-names-toggle' + (mmNamesOff ? ' is-off' : '') + '" id="mm-names-toggle">' +
      '<label class="mm-switch">' +
        '<input type="checkbox" id="mm-names-on"' + (mmNamesOff ? '' : ' checked') + '>' +
        '<span class="mm-switch-track" aria-hidden="true"><span class="mm-switch-knob"></span></span>' +
        '<span class="mm-switch-text"><strong>Show names on the drawing</strong>' +
        '<span class="mm-switch-help" id="mm-names-help"></span></span>' +
      '</label>' +
      '<input type="hidden" id="mm-names-value" name="properties[Names on Drawing]" value="No"' + (mmNamesOff ? '' : ' disabled') + '>' +
    '</div>';
  }

  function mmApplyNamesToggle() {
    var box = document.getElementById('mm-names-toggle');
    if (!box) return;
    box.classList.toggle('is-off', mmNamesOff);
    document.getElementById('mm-names-value').disabled = !mmNamesOff;
    document.getElementById('mm-names-help').textContent = mmNamesOff
      ? 'No names: Maisie will leave them off. Names above are optional, just so she knows who is who.'
      : 'Turn off for a drawing with no names under it.';
    document.querySelectorAll('[id^="mm-name-"]').forEach(function(input) {
      input.placeholder = mmNamesOff ? 'Name (optional, not drawn)' : 'Name, as it should appear';
    });
    // Already told to add names? Check again, so those messages go once names are optional.
    var shown = document.getElementById('mm-form-error');
    if (mmNamesOff && shown && shown.textContent && typeof window.mmCheckOrder === 'function') window.mmCheckOrder();
    mmUpdateSummary();
  }

  function generateHandsHTML(personCount) {
    mmHands = {};
    if (personCount === 2) mmHands[1] = true; // Munch for Two starts holding hands (Noah, 17 Oct)
    return '<div class="mm-hands" id="mm-hands">' +
      '<div class="mm-person-header"><div class="mm-person-title">Holding hands</div><span class="mm-optional">optional</span></div>' +
      '<p class="mm-hands-help">This is the order they will stand in, left to right. Tap the hand between two people to have them holding hands.</p>' +
      // Arrows at each edge appear only when the line-up is wider than the space (Munch for Five to Eight).
      '<div class="mm-lineup-wrap" id="mm-lineup-wrap">' +
        '<button type="button" class="mm-lineup-arrow mm-lineup-arrow--prev" data-dir="-1" aria-label="Scroll left">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<div class="mm-lineup" id="mm-lineup"></div>' +
        '<button type="button" class="mm-lineup-arrow mm-lineup-arrow--next" data-dir="1" aria-label="Scroll right">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '</div>' +
      '<div class="mm-hands-says" id="mm-hands-says"></div>' +
      '<input type="hidden" id="mm-hands-value" name="properties[Holding Hands]" value="None">' +
    '</div>';
  }

  // Show each arrow only when there is more of the line-up to see in that direction.
  function mmLineupArrows() {
    var lineup = document.getElementById('mm-lineup');
    var wrap = document.getElementById('mm-lineup-wrap');
    if (!lineup || !wrap) return;
    var more = lineup.scrollWidth - lineup.clientWidth;
    var left = more > 2 && lineup.scrollLeft > 2;
    var right = more > 2 && lineup.scrollLeft < more - 2;
    wrap.classList.toggle('can-left', left);
    wrap.classList.toggle('can-right', right);
  }

  function mmWireLineup() {
    var lineup = document.getElementById('mm-lineup');
    if (!lineup || lineup.getAttribute('data-wired')) return;
    lineup.setAttribute('data-wired', '1');
    lineup.addEventListener('scroll', mmLineupArrows, { passive: true });
    window.addEventListener('resize', mmLineupArrows);
    document.getElementById('mm-lineup-wrap').addEventListener('click', function(e) {
      var arrow = e.target.closest('.mm-lineup-arrow');
      if (!arrow) return;
      // Move about two people at a time
      lineup.scrollBy({ left: parseInt(arrow.getAttribute('data-dir'), 10) * Math.max(140, lineup.clientWidth * 0.6), behavior: 'smooth' });
    });
  }

  function mmPersonName(num) {
    var input = document.getElementById('mm-name-' + num);
    return input ? input.value.replace(/\s+/g, ' ').trim() : '';
  }

  function mmPersonItem(num) {
    var v = document.getElementById('mm-drink-value-' + num);
    return v && v.value && mmIndex ? mmIndex.byName[v.value.toLowerCase()] || null : null;
  }

  // Keep the line-up showing the chosen drawings and names, and the order property in step.
  window.mmUpdateHands = function() {
    var value = document.getElementById('mm-hands-value');
    var lineup = document.getElementById('mm-lineup');
    if (!value || !lineup) return;
    var count = document.querySelectorAll('.mm-person').length;
    var html = '';
    var pairs = [];
    var says = [];
    var n, a, b, names, item, label;
    for (n = 1; n <= count; n++) {
      if (n > 1) {
        html += '<button type="button" class="mm-hand' + (mmHands[n - 1] ? ' is-on' : '') + '" data-pair="' + (n - 1) + '" aria-pressed="' + (mmHands[n - 1] ? 'true' : 'false') + '" ' +
          'aria-label="Person ' + (n - 1) + ' and Person ' + n + ' holding hands">' +
          (mmHands[n - 1] ? '<svg viewBox="0 0 28 18" width="28" height="18" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><circle cx="9.5" cy="9" r="6"/><circle cx="18.5" cy="9" r="6"/></svg>' : '+') +
        '</button>';
      }
      item = mmPersonItem(n);
      label = mmPersonName(n) || 'Person ' + n;
      html += '<div class="mm-who"><div class="mm-who-pic">' + (item ? '<img src="' + mmSized(item.t, 144) + '" alt="">' : n) + '</div>' +
        '<div class="mm-who-name">' + mmEsc(label) + '</div></div>';
    }
    // Redrawing resets the scroll, so keep the customer where they were (e.g. tapping a hand on the right).
    var keep = lineup.scrollLeft;
    lineup.classList.toggle('mm-lineup--compact', count >= 5);
    lineup.innerHTML = html;
    lineup.scrollLeft = keep;
    mmLineupArrows();
    for (n = 1; n < count; n++) {
      a = mmPersonName(n);
      b = mmPersonName(n + 1);
      names = (a || b) ? (a || 'Person ' + n) + ' & ' + (b || 'Person ' + (n + 1)) : '';
      if (mmHands[n]) {
        pairs.push('Person ' + n + ' & ' + (n + 1) + (names ? ' (' + names + ')' : ''));
        says.push(names || 'Person ' + n + ' & Person ' + (n + 1));
      }
    }
    value.value = pairs.length ? pairs.join('; ') : 'None';
    document.getElementById('mm-hands-says').textContent = says.length ? 'Holding hands: ' + says.join(', ') : 'No one holding hands';
  };

  // A short line above Add to cart: who is ready and as what.
  function mmUpdateSummary() {
    var box = document.getElementById('mm-summary');
    if (!box) return;
    var persons = document.querySelectorAll('.mm-person');
    var optional = mmChoiceOptionalHere();
    var ready = 0;
    var parts = [];
    var i, num, name, item, isPersonalities = getMode() === 'personalities';
    var noNames = mmNamesOff && !!document.getElementById('mm-names-toggle');
    for (i = 0; i < persons.length; i++) {
      num = i + 1;
      name = mmPersonName(num);
      item = mmPersonItem(num);
      if ((isPersonalities || noNames || name) && (item || optional)) ready++;
      if (name || item) parts.push(mmEsc(name || (isPersonalities ? 'Personality ' : 'Person ') + num) + (item ? ' as ' + mmEsc(item.n) : ''));
    }
    box.innerHTML = '<b>' + ready + ' of ' + persons.length + (persons.length === 1 ? (isPersonalities ? ' personality' : ' person') : (isPersonalities ? ' personalities' : ' people')) + ' ready</b>' +
      (parts.length ? '<span>' + parts.join(', ') + '</span>' : '');
    if (noNames) box.innerHTML += '<span>No names on the drawing</span>';
    box.classList.toggle('is-ready', ready === persons.length);
  }

  // ---- Results list ----
  function mmCloseResults(except) {
    var lists = document.querySelectorAll('.mm-results.show');
    var i;
    for (i = 0; i < lists.length; i++) {
      if (lists[i].id === except) continue;
      lists[i].classList.remove('show');
      var input = document.getElementById('mm-q-' + lists[i].id.split('-').pop());
      if (input) input.setAttribute('aria-expanded', 'false');
    }
  }

  function mmRenderResults(num, list, heading) {
    var box = document.getElementById('mm-dropdown-' + num);
    var input = document.getElementById('mm-q-' + num);
    var html = heading ? '<div class="mm-results-head">' + mmEsc(heading) + '</div>' : '';
    var i, it;
    if (!list.length) {
      html += '<div class="mm-no-results">Nothing called that yet. Try one word, like “gin” or “crisps”, or browse the menu. ' +
        'Maisie can also draw something new as a <a href="/pages/bespoke-munch">bespoke Munch</a>.</div>';
    }
    for (i = 0; i < list.length && i < MM_SHOW; i++) {
      it = list[i];
      html += '<div class="mm-option" role="option" id="mm-opt-' + num + '-' + i + '" data-name="' + mmEsc(it.n) + '">' +
        '<img src="' + (mmSized(it.t, 144) || mmFallback) + '" data-full="' + mmEsc(it.t || '') + '" alt="" loading="lazy" onerror="this.src=\'' + mmFallback + '\'">' +
        '<span class="mm-option-text"><span class="mm-option-name">' + mmEsc(it.n) + '</span>' +
        '<span class="mm-option-where">' + it.k + ' · ' + mmEsc(it.c.join(', ')) + '</span></span></div>';
    }
    if (list.length > MM_SHOW) html += '<div class="mm-no-results">Showing ' + MM_SHOW + ' of ' + list.length + '. Keep typing to narrow it down.</div>';
    box.innerHTML = html;
    box.scrollTop = 0;
    box.setAttribute('data-hl', '-1');
    mmCloseResults(box.id);
    box.classList.add('show');
    if (input) input.setAttribute('aria-expanded', 'true');
  }

  function mmHighlight(num, step) {
    var box = document.getElementById('mm-dropdown-' + num);
    var opts = box.querySelectorAll('.mm-option');
    if (!opts.length) return;
    var hl = parseInt(box.getAttribute('data-hl'), 10);
    hl = Math.max(0, Math.min(opts.length - 1, (isNaN(hl) ? -1 : hl) + step));
    box.setAttribute('data-hl', hl);
    var i;
    for (i = 0; i < opts.length; i++) opts[i].classList.toggle('is-hl', i === hl);
    opts[hl].scrollIntoView({ block: 'nearest' });
    document.getElementById('mm-q-' + num).setAttribute('aria-activedescendant', opts[hl].id);
  }

  // Choose a drawing for a person, or clear it (item null). quiet: clear without focusing the
  // search box (used when reordering, so the phone keyboard does not pop up).
  function mmChoose(num, item, quiet) {
    var value = document.getElementById('mm-drink-value-' + num);
    var selected = document.getElementById('mm-selected-' + num);
    var img = document.getElementById('mm-selected-img-' + num);
    var input = document.getElementById('mm-q-' + num);
    var show = function(id, on) { var el = document.getElementById(id); if (el) el.style.display = on ? '' : 'none'; };
    if (item) {
      value.value = item.n;
      value.name = 'properties[' + mmPropPrefix(num) + ' ' + (item.k === 'Food' ? 'Food' : 'Drink') + ']';
      img.src = mmSized(item.t, 200) || mmFallback;
      img.setAttribute('data-full', item.t || '');
      img.onerror = function() { this.src = mmFallback; };
      document.getElementById('mm-selected-name-' + num).textContent = item.n;
      selected.classList.add('show');
      show('mm-pick-box-' + num, false);
      show('mm-browse-' + num, false);
      document.getElementById('mm-chips-' + num).classList.remove('show');
      mmCloseResults();
    } else {
      value.value = '';
      value.name = 'properties[' + mmPropPrefix(num) + ' Choice]';
      selected.classList.remove('show');
      show('mm-pick-box-' + num, true);
      show('mm-browse-' + num, true);
      input.value = '';
      if (!quiet) input.focus();
    }
    window.mmUpdateHands();
    mmUpdateSummary();
    if (window.mmCheckOrderQuiet && document.getElementById('mm-form-error')) window.mmCheckOrderQuiet();
  }

  // Swap two people's names and drawings, so customers can change who stands where (left to right).
  // Holding hands stays with the positions; the line-up redraws so they can see the new order.
  function mmSwapPeople(a, b, button) {
    var na = document.getElementById('mm-name-' + a);
    var nb = document.getElementById('mm-name-' + b);
    if (na && nb) { var name = na.value; na.value = nb.value; nb.value = name; }
    var ia = mmPersonItem(a);
    var ib = mmPersonItem(b);
    mmChoose(a, ib, true);
    mmChoose(b, ia, true);
    [a, b].forEach(function(n) {
      var card = document.querySelector('.mm-person[data-num="' + n + '"]');
      if (!card) return;
      card.classList.remove('mm-person--moved');
      void card.offsetWidth; // restart the highlight
      card.classList.add('mm-person--moved');
    });
    // Keep the moved person in view and the focus on its arrow, so it can be moved again straight away
    var moved = document.querySelector('.mm-person[data-num="' + b + '"]');
    if (moved && moved.scrollIntoView) moved.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    if (button) {
      var again = document.querySelector('.mm-move-btn[data-num="' + b + '"][data-dir="' + button.getAttribute('data-dir') + '"]');
      if (again && !again.disabled) again.focus({ preventScroll: true });
    }
  }

  function mmShowChips(num) {
    var chips = document.getElementById('mm-chips-' + num);
    var btn = document.querySelector('.mm-browse-btn[data-num="' + num + '"]');
    if (!chips.innerHTML) {
      var html = '';
      ['Drinks', 'Food'].forEach(function(type) {
        if (!mmAllData[type]) return;
        html += '<div class="mm-chip-row"><span class="mm-chip-type">' + type + '</span>' + Object.keys(mmAllData[type]).sort().map(function(cat) {
          return '<button type="button" class="mm-chip" data-num="' + num + '" data-type="' + type + '" data-cat="' + mmEsc(cat) + '">' + mmEsc(cat) + '</button>';
        }).join('') + '</div>';
      });
      chips.innerHTML = html;
    }
    var open = !chips.classList.contains('show');
    chips.classList.toggle('show', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // One set of listeners for every person on the page
  function mmWirePicker(container) {
    container.addEventListener('input', function(e) {
      var t = e.target;
      if (t.classList.contains('mm-pick-input')) {
        var num = t.getAttribute('data-num');
        var q = t.value.trim();
        if (!q) { mmCloseResults(); return; }
        var hits = mmSearch(q);
        mmRenderResults(num, hits, hits.length ? hits.length + (hits.length === 1 ? ' match' : ' matches') : '');
      } else if (/^mm-name-\d+$/.test(t.id)) {
        window.mmUpdateHands();
        mmUpdateSummary();
      }
    });
    container.addEventListener('keydown', function(e) {
      var t = e.target;
      if (!t.classList.contains('mm-pick-input')) return;
      var num = t.getAttribute('data-num');
      var box = document.getElementById('mm-dropdown-' + num);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!box.classList.contains('show') && t.value.trim()) mmRenderResults(num, mmSearch(t.value), '');
        mmHighlight(num, e.key === 'ArrowDown' ? 1 : -1);
        e.preventDefault();
      } else if (e.key === 'Enter') {
        // Enter must never send the form from here: it picks the highlighted (or only) drawing.
        e.preventDefault();
        var opts = box.querySelectorAll('.mm-option');
        var hl = parseInt(box.getAttribute('data-hl'), 10);
        var pick = opts[hl >= 0 ? hl : 0];
        if (box.classList.contains('show') && pick && (hl >= 0 || opts.length === 1)) {
          mmChoose(num, mmIndex.byName[pick.getAttribute('data-name').toLowerCase()]);
        }
      } else if (e.key === 'Escape') {
        mmCloseResults();
      }
    });
    container.addEventListener('click', function(e) {
      var t = e.target;
      var opt = t.closest('.mm-option');
      if (opt && opt.closest('.mm-results')) {
        var num = opt.closest('.mm-results').id.split('-').pop();
        mmChoose(num, mmIndex.byName[opt.getAttribute('data-name').toLowerCase()]);
        return;
      }
      var change = t.closest('.mm-change');
      if (change) { mmChoose(change.getAttribute('data-num'), null); return; }
      var move = t.closest('.mm-move-btn');
      if (move) {
        var from = parseInt(move.getAttribute('data-num'), 10);
        var to = from + parseInt(move.getAttribute('data-dir'), 10);
        if (to >= 1 && to <= document.querySelectorAll('.mm-person').length) mmSwapPeople(from, to, move);
        return;
      }
      var browse = t.closest('.mm-browse-btn');
      if (browse) { mmShowChips(browse.getAttribute('data-num')); return; }
      var chip = t.closest('.mm-chip');
      if (chip) {
        var n = chip.getAttribute('data-num');
        var type = chip.getAttribute('data-type');
        var cat = chip.getAttribute('data-cat');
        var items = (mmAllData[type][cat] || []).map(function(x) { return mmIndex.byName[x.n.toLowerCase()]; }).filter(Boolean);
        var chipsHere = document.querySelectorAll('#mm-chips-' + n + ' .mm-chip');
        var i;
        for (i = 0; i < chipsHere.length; i++) chipsHere[i].classList.toggle('is-on', chipsHere[i] === chip);
        mmRenderResults(n, items, cat + ' · ' + items.length);
        return;
      }
      var hand = t.closest('.mm-hand');
      if (hand) {
        var p = hand.getAttribute('data-pair');
        mmHands[p] = !mmHands[p];
        window.mmUpdateHands();
      }
    });
    // Close any open list when tapping elsewhere on the page
    document.addEventListener('click', function(e) {
      if (!e.target.closest || (!e.target.closest('.mm-pick') && !e.target.closest('.mm-chips'))) mmCloseResults();
    });
  }

  // Build person sections
  function mmBuildPersonSections(personCount) {
    var container = document.getElementById('mm-persons-container');
    var html = '<div class="mm-step-title">' + (getMode() === 'personalities' ? 'Choose the favourites' : 'Who’s in it?') + '</div>' +
      (personCount > 1 ? '<p class="mm-order-hint">They appear left to right in this order. Use the arrows to move anyone up or down.</p>' : '');
    var i;
    for (i = 1; i <= personCount; i++) {
      html += generatePersonHTML(i);
    }
    if (mmNamesToggleEnabled()) {
      html += generateNamesToggleHTML();
    }
    if (mmHandsEnabled(personCount)) {
      html += generateHandsHTML(personCount);
    }
    container.innerHTML = html;
    var namesOn = document.getElementById('mm-names-on');
    if (namesOn) {
      namesOn.addEventListener('change', function() { mmNamesOff = !namesOn.checked; mmApplyNamesToggle(); });
      mmApplyNamesToggle();
    }
    mmWirePicker(container);
    mmWireLineup();
    window.mmUpdateHands();

    // The optional title (or the Personalities caption) stays first, above the people (Noah,
    // 18 Oct), then a summary line goes just above Add to cart.
    var form = document.getElementById('mm-drink-form');
    var title = document.getElementById('mm-title-field');
    if (title) {
      var label = title.querySelector('.mm-label');
      if (label) label.innerHTML = 'Drawing title <span class="mm-optional">optional</span>';
      title.classList.add('mm-title-first');
    }
    var summary = document.createElement('div');
    summary.id = 'mm-summary';
    summary.className = 'mm-summary';
    form.appendChild(summary);
    mmUpdateSummary();
  }

  // ---- The print options above (size, proof, frame) ----
  // Presentation only: the same Shopify options and variants. Frames show what they add for the
  // chosen size, the proof question goes after the frame, Add to cart becomes the main button.
  var mmVariants = null;

  function mmLoadVariants() {
    var el = document.getElementById('mm-product-handle');
    if (!el || mmVariants) return Promise.resolve();
    return fetch('/products/' + el.dataset.handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) { mmVariants = p && p.variants ? p.variants : []; })
      .catch(function() { mmVariants = []; });
  }

  function mmMoney(pence) {
    var pounds = pence / 100;
    return '£' + (pounds % 1 ? pounds.toFixed(2) : pounds);
  }

  function mmDecoratePrintOptions() {
    var selects = document.querySelector('variant-selects');
    if (!selects || !mmVariants || !mmVariants.length) return;
    var sets = selects.querySelectorAll('fieldset');
    var sizeIdx = -1, proofIdx = -1, frameIdx = -1;
    var i;
    for (i = 0; i < sets.length; i++) {
      var legend = (sets[i].querySelector('legend') || {}).textContent || '';
      if (/^\s*size/i.test(legend)) sizeIdx = i;
      else if (/proof/i.test(legend)) proofIdx = i;
      else if (/frame/i.test(legend)) frameIdx = i;
    }
    if (proofIdx !== -1) {
      sets[proofIdx].classList.add('mm-proof-set');
      var lg = sets[proofIdx].querySelector('legend');
      if (lg && !lg.getAttribute('data-mm')) { lg.setAttribute('data-mm', '1'); lg.textContent = 'See a proof before it’s printed? (+£10)'; }
    }
    if (sizeIdx === -1 || frameIdx === -1) return;
    var checkedSize = sets[sizeIdx].querySelector('input:checked');
    var checkedProof = proofIdx !== -1 ? sets[proofIdx].querySelector('input:checked') : null;
    if (!checkedSize) return;
    var opt = function(v, idx) { return v.options[idx]; };
    var base = mmVariants.filter(function(v) {
      return opt(v, sizeIdx) === checkedSize.value && /unframed/i.test(opt(v, frameIdx)) && (!checkedProof || opt(v, proofIdx) === checkedProof.value);
    })[0];
    if (!base) return;
    var labels = sets[frameIdx].querySelectorAll('input');
    for (i = 0; i < labels.length; i++) {
      var input = labels[i];
      var lab = sets[frameIdx].querySelector('label[for="' + input.id + '"]');
      if (!lab) continue;
      var match = mmVariants.filter(function(v) {
        return opt(v, sizeIdx) === checkedSize.value && opt(v, frameIdx) === input.value && (!checkedProof || opt(v, proofIdx) === checkedProof.value);
      })[0];
      var text = /unframed/i.test(input.value) ? 'no frame' : match ? '+' + mmMoney(match.price - base.price) : '';
      var add = lab.querySelector('.mm-pill-add');
      if (!add) { add = document.createElement('span'); add.className = 'mm-pill-add'; lab.appendChild(add); }
      // Only touch the page when the text really changes, or the observer below would loop.
      if (add.textContent !== text) add.textContent = text;
    }
  }

  function mmSetUpPrintOptions() {
    var info = document.querySelector('.product__info-container') || document.body;
    var selects = document.querySelector('variant-selects');
    if (selects && !document.querySelector('.mm-step-title--print')) {
      var h = document.createElement('div');
      h.className = 'mm-step-title mm-step-title--print';
      h.textContent = 'Your print';
      selects.parentNode.insertBefore(h, selects);
    }
    var submit = document.querySelector('#mm-drink-form') && document.querySelector('#mm-drink-form').closest('form').querySelector('.product-form__submit');
    if (submit) { submit.classList.remove('button--secondary'); submit.classList.add('button--primary', 'mm-add'); }
    document.documentElement.classList.add('mm-munch-page');
    mmLoadVariants().then(mmDecoratePrintOptions);
    // The theme redraws the option buttons whenever a choice changes, so decorate them again.
    var timer = null;
    new MutationObserver(function() {
      clearTimeout(timer);
      timer = setTimeout(mmDecoratePrintOptions, 30);
    }).observe(info, { childList: true, subtree: true });
  }

  // Initialize the form
  function mmInit() {
    var form = document.getElementById('mm-drink-form');
    var loading = document.getElementById('mm-loading');
    var errorEl = document.getElementById('mm-error');
    var titleField = document.getElementById('mm-title-field');

    // Only show the form for drink/food customization products
    if (!isDrinkProduct()) {
      form.style.display = 'none';
      return;
    }

    // Fetch data from Google Sheets
    loadAllData()
      .then(function() {
        // Hide loading, show form content
        loading.style.display = 'none';
        titleField.style.display = shouldShowTitle() ? '' : 'none';

        // Personalities products get the caption box instead of a free-text title
        var ownerField = document.getElementById('mm-owner-field');
        if (ownerField && getMode() === 'personalities') {
          ownerField.style.display = '';
          var ownerInput = document.getElementById('mm-owner');
          if (ownerInput) {
            ownerInput.addEventListener('input', window.mmUpdateCaption);
          }
          window.mmUpdateCaption();
        }

        var totalItems = 0;
        var type;
        for (type in mmAllData) {
          var cat;
          for (cat in mmAllData[type]) {
            totalItems += mmAllData[type][cat].length;
          }
        }
        console.log('Maisie\'s Munch: Loaded ' + totalItems + ' items from ' + Object.keys(mmAllData).length + ' types');

        mmBuildIndex();
        var personCount = getPersonCount();
        mmBuildPersonSections(personCount);
        mmSetUpPrintOptions();
      })
      .catch(function(err) {
        loading.style.display = 'none';
        errorEl.style.display = '';
        errorEl.textContent = 'Could not load menu data. Please refresh the page.';
        console.error('Maisie\'s Munch load error:', err);
      });
  }

  // ---- Stop an order going in with names or favourites missing ----
  // The theme's product form has novalidate, so the "required" fields above do nothing on their
  // own: without this check a Munch could be added to the basket with every box blank.
  // The Wedding Present (Champagne only) needs names but no food or drink choices.
  function mmChoiceOptional() {
    var el = document.getElementById('mm-product-handle');
    return /champagne/.test(((el && el.dataset.handle) || '').toLowerCase());
  }

  function mmShowFormMessage(text) {
    var form = document.getElementById('mm-drink-form');
    var box = document.getElementById('mm-form-error');
    if (!box && form) {
      box = document.createElement('div');
      box.id = 'mm-form-error';
      box.className = 'mm-form-error';
      box.setAttribute('role', 'alert');
      var buttons = form.closest('form') && form.closest('form').querySelector('.product-form__buttons');
      if (buttons) buttons.parentNode.insertBefore(box, buttons);
      else form.appendChild(box);
    }
    if (!box) return;
    box.textContent = text || '';
    box.style.display = text ? '' : 'none';
  }

  // Returns true when every person has what Maisie needs; otherwise marks what is missing.
  window.mmCheckOrder = function() {
    if (!isDrinkProduct()) return true;
    var persons = document.querySelectorAll('.mm-person');
    if (!persons.length) {
      mmShowFormMessage('The menu is still loading. Please wait a moment, or refresh the page if this stays.');
      return false;
    }
    var choiceOptional = mmChoiceOptional();
    var missing = [];
    var firstField = null;
    var i, num, nameEl, valueEl, needsName, needsChoice, err, person, text;
    for (i = 0; i < persons.length; i++) {
      person = persons[i];
      num = i + 1;
      nameEl = document.getElementById('mm-name-' + num);
      valueEl = document.getElementById('mm-drink-value-' + num);
      needsName = !!nameEl && !(mmNamesOff && document.getElementById('mm-names-toggle')) && !nameEl.value.replace(/\s+/g, ' ').trim();
      needsChoice = !choiceOptional && !!valueEl && !valueEl.value;
      err = person.querySelector('.mm-person-error');
      if (!err) {
        err = document.createElement('div');
        err.className = 'mm-person-error';
        person.appendChild(err);
      }
      if (!needsName && !needsChoice) {
        person.classList.remove('mm-person--invalid');
        err.textContent = '';
        continue;
      }
      text = needsName && needsChoice ? 'Please add a name and choose a food or drink.' :
        needsName ? 'Please add a name.' : 'Please choose a food or drink.';
      err.textContent = text;
      person.classList.add('mm-person--invalid');
      missing.push(person.querySelector('.mm-person-title') ? person.querySelector('.mm-person-title').textContent : 'Person ' + num);
      if (!firstField) {
        firstField = needsName ? nameEl : person.querySelector('[data-mm-first-choice]') ||
          (document.getElementById('mm-type-' + num) && !document.getElementById('mm-type-' + num).value ? document.getElementById('mm-type-' + num) : document.getElementById('mm-drink-input-' + num)) || person;
      }
    }
    if (!missing.length) {
      mmShowFormMessage('');
      return true;
    }
    mmShowFormMessage('Almost there: ' + missing.join(', ') + (missing.length === 1 ? ' still needs' : ' still need') +
      ' the details marked in red before this can go in your basket.');
    if (firstField) {
      firstField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (firstField.focus) setTimeout(function() { try { firstField.focus({ preventScroll: true }); } catch (e) {} }, 400);
    }
    return false;
  };

  // Clear a person's red message as soon as they fix it.
  document.addEventListener('input', function(e) {
    var person = e.target.closest && e.target.closest('.mm-person--invalid');
    if (person && document.getElementById('mm-form-error')) window.mmCheckOrderQuiet();
  });
  document.addEventListener('change', function(e) {
    var person = e.target.closest && e.target.closest('.mm-person--invalid');
    if (person && document.getElementById('mm-form-error')) window.mmCheckOrderQuiet();
  });
  // Re-check without scrolling, so fixed people lose their red mark while typing.
  window.mmCheckOrderQuiet = function() {
    var persons = document.querySelectorAll('.mm-person--invalid');
    var choiceOptional = mmChoiceOptional();
    var i, num, person, nameEl, valueEl;
    for (i = 0; i < persons.length; i++) {
      person = persons[i];
      num = Array.prototype.indexOf.call(document.querySelectorAll('.mm-person'), person) + 1;
      nameEl = document.getElementById('mm-name-' + num);
      valueEl = document.getElementById('mm-drink-value-' + num);
      if ((!nameEl || nameEl.value.trim()) && (choiceOptional || !valueEl || valueEl.value)) {
        person.classList.remove('mm-person--invalid');
        if (person.querySelector('.mm-person-error')) person.querySelector('.mm-person-error').textContent = '';
      }
    }
    if (!document.querySelector('.mm-person--invalid')) mmShowFormMessage('');
  };

  // Add to cart and Buy with Shop. Listening on window in the capture phase means this runs before
  // the theme's form and before the product options app on the wedding and engagement products,
  // which catches the Add to cart click itself and adds the item without going through the form.
  function mmStop(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
  window.addEventListener('click', function(e) {
    var t = e.target;
    if (!t || !t.closest || !document.querySelector('#mm-drink-form')) return;
    var add = t.closest('[name="add"], .product-form__submit');
    var pay = t.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button');
    if (add && !(add.form && add.form.querySelector('#mm-drink-form'))) return;
    if ((add || pay) && !window.mmCheckOrder()) mmStop(e);
  }, true);
  window.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector('#mm-drink-form')) return;
    if (!window.mmCheckOrder()) mmStop(e);
  }, true);

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mmInit);
  } else {
    mmInit();
  }
})();

/*
  Larger, watermarked preview of a drop-down drawing.
  Desktop: hovering an option shows the drawing bigger beside the list.
  Any device: clicking or tapping the "Selected" picture opens it larger, and so does
  clicking the main product picture (instead of the theme's unwatermarked lightbox).
  The drawing is painted onto a canvas with "© Maisie's Munch" running across it,
  so a screenshot or saved copy of the preview carries the mark.
*/
(function() {
  'use strict';

  if (window.mmZoomReady) return;
  window.mmZoomReady = true;

  var MARK = '© Maisie’s Munch';
  var HOVER_SIZE = 260;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var images = {};

  function loadImage(url) {
    if (!images[url]) {
      images[url] = new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() { resolve(img); };
        img.onerror = reject;
        img.src = url;
      });
    }
    return images[url];
  }

  function fontReady() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return document.fonts.load('600 15px "Bricolage Grotesque"').catch(function() {});
  }

  // Paint the drawing, then rows of the watermark across it. Returns the size used.
  function paint(canvas, img, maxSize) {
    var natural = Math.max(img.naturalWidth, img.naturalHeight);
    // The few drawings that only exist as small originals are kept smaller rather than blurred.
    var size = natural < 200 ? Math.min(maxSize, 170) : maxSize;
    var ratio = window.devicePixelRatio || 1;
    var ctx = canvas.getContext('2d');
    var scale = Math.min(size / img.naturalWidth, size / img.naturalHeight);
    var w = img.naturalWidth * scale;
    var h = img.naturalHeight * scale;
    var x, y, row, gap, step, width;

    canvas.width = canvas.height = Math.round(size * ratio);
    canvas.style.width = canvas.style.height = size + 'px';
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    ctx.clearRect(0, 0, size, size);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);

    ctx.save();
    ctx.translate(size / 2, size / 2);
    ctx.rotate(-Math.PI / 6);
    // Watermark text grows with the picture: 15px on the small previews, larger on the product view.
    var fontSize = Math.max(15, Math.round(size / 24));
    ctx.font = '600 ' + fontSize + 'px "Bricolage Grotesque", Poppins, sans-serif';
    ctx.fillStyle = size > 400 ? 'rgba(90, 62, 43, 0.19)' : 'rgba(90, 62, 43, 0.24)';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    gap = fontSize * 1.7;
    width = ctx.measureText(MARK).width + gap;
    step = fontSize * 2.9;
    for (row = 0, y = -size; y <= size; y += step, row++) {
      for (x = -size - (row % 2) * width / 2; x <= size + width; x += width) {
        ctx.fillText(MARK, x, y);
      }
    }
    ctx.restore();
    return size;
  }

  function buildCard(extraClass) {
    var card = document.createElement('div');
    card.className = 'mm-zoom ' + extraClass;
    card.innerHTML = '<canvas class="mm-zoom__canvas"></canvas><div class="mm-zoom__name"></div>';
    card.addEventListener('contextmenu', function(e) { e.preventDefault(); });
    return card;
  }

  function fill(card, url, name, maxSize) {
    var canvas = card.querySelector('canvas');
    card.querySelector('.mm-zoom__name').textContent = name || '';
    card.setAttribute('data-url', url);
    return Promise.all([loadImage(url), fontReady()]).then(function(r) {
      if (card.getAttribute('data-url') !== url) return false; // moved on to another item
      paint(canvas, r[0], maxSize);
      return true;
    });
  }

  // ---- Desktop hover preview ----
  var hoverCard = null;
  var hoverOption = null;

  function placeHoverCard(option) {
    var list = option.closest('.mm-dropdown') || option;
    var box = list.getBoundingClientRect();
    var row = option.getBoundingClientRect();
    var cw = hoverCard.offsetWidth;
    var ch = hoverCard.offsetHeight;
    var left = box.left - cw - 14;
    if (left < 8) left = box.right + 14;
    if (left + cw > window.innerWidth - 8) left = Math.max(8, window.innerWidth - cw - 8);
    var top = row.top + row.height / 2 - ch / 2;
    top = Math.max(8, Math.min(top, window.innerHeight - ch - 8));
    hoverCard.style.left = left + 'px';
    hoverCard.style.top = top + 'px';
  }

  function hideHover() {
    hoverOption = null;
    if (hoverCard) hoverCard.classList.remove('is-visible');
  }

  if (canHover) {
    document.addEventListener('mouseover', function(e) {
      var option = e.target.closest && e.target.closest('.mm-option');
      if (!option) {
        if (hoverOption && !(e.target.closest && e.target.closest('.mm-dropdown'))) hideHover();
        return;
      }
      if (option === hoverOption) return;
      var img = option.querySelector('img');
      var url = img && img.getAttribute('data-full');
      if (!url) { hideHover(); return; }
      if (!hoverCard) {
        hoverCard = buildCard('mm-zoom--hover');
        hoverCard.setAttribute('aria-hidden', 'true');
        document.body.appendChild(hoverCard);
      }
      hoverOption = option;
      var nameEl = option.querySelector('.mm-option-name');
      fill(hoverCard, url, nameEl ? nameEl.textContent : '', HOVER_SIZE).then(function(ok) {
        if (!ok || hoverOption !== option) return;
        hoverCard.classList.add('is-visible');
        placeHoverCard(option);
      }).catch(hideHover);
    });
    document.addEventListener('click', hideHover, true);
    window.addEventListener('scroll', function() {
      if (hoverOption) placeHoverCard(hoverOption);
    }, true);
  }

  // ---- Larger view of the selected drawing (click or tap) ----
  var modal = null;

  function closeModal() {
    if (modal) modal.classList.remove('is-open');
  }

  function openModal(url, name, size) {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'mm-zoom-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Larger view of the drawing');
      var card = buildCard('mm-zoom--modal');
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'mm-zoom__close';
      close.setAttribute('aria-label', 'Close');
      close.innerHTML = '&times;';
      card.insertBefore(close, card.firstChild);
      modal.appendChild(card);
      modal.addEventListener('click', function(e) {
        if (e.target === modal || e.target.closest('.mm-zoom__close')) closeModal();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeModal();
      });
      document.body.appendChild(modal);
    }
    size = size || Math.min(320, window.innerWidth - 72);
    var card = modal.querySelector('.mm-zoom');
    var canvas = card.querySelector('canvas');
    // Blank the canvas at the new size so the previous drawing never flashes up while loading.
    canvas.width = canvas.height = 1;
    canvas.style.width = canvas.style.height = size + 'px';
    modal.classList.add('is-open');
    fill(card, url, name, size).catch(closeModal);
    modal.querySelector('.mm-zoom__close').focus();
  }

  document.addEventListener('click', function(e) {
    var img = e.target.closest && e.target.closest('.mm-selected img');
    if (!img) return;
    var url = img.getAttribute('data-full');
    if (!url) return;
    var box = img.closest('.mm-selected');
    var nameEl = box && box.querySelector('.mm-selected-name');
    openModal(url, nameEl ? nameEl.textContent : '');
  });

  // ---- Product pictures: open the watermarked view instead of the theme's plain lightbox ----
  // Only on the personalised Munch products (where the Person form is built); this script also
  // loads on other product pages, which keep the theme's own zoom.
  function sizedUrl(src, width) {
    var url = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  document.addEventListener('click', function(e) {
    var opener = e.target.closest && e.target.closest('.product__modal-opener--image');
    if (!opener || !document.querySelector('.mm-person')) return;
    var img = opener.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (!src) return;
    e.preventDefault();
    e.stopPropagation();
    var size = Math.max(240, Math.min(820, window.innerWidth - 72, window.innerHeight - 150));
    var ratio = Math.min(window.devicePixelRatio || 1, 2);
    var title = document.querySelector('.product__title h1') || document.querySelector('h1');
    openModal(sizedUrl(src, Math.round(size * ratio)), title ? title.textContent.trim() : '', size);
  }, true);

  // ---- Amazon-style magnifier on the main product picture (desktop, Munch products only) ----
  // A lens follows the mouse over the picture and a large close-up beside it shows the
  // brushstrokes. The close-up carries a light watermark. Clicking still opens the full view.
  var magnifier = null;

  // Zoom far enough that the close-up shows the artwork at roughly the size Maisie drew it
  // (the 4500px product picture holds it at about 1.5x), within sensible limits.
  function zoomFor(width) {
    return Math.max(3, Math.min(6, 2400 / width));
  }

  function lightMark(ctx, w, h) {
    var fontSize = Math.max(14, Math.round(w / 26));
    var span = Math.max(w, h);
    var width, step, row, x, y;
    ctx.save();
    ctx.translate(w / 2, h / 2);
    ctx.rotate(-Math.PI / 6);
    ctx.font = '600 ' + fontSize + 'px "Bricolage Grotesque", Poppins, sans-serif';
    ctx.fillStyle = 'rgba(90, 62, 43, 0.12)';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    width = ctx.measureText(MARK).width + fontSize * 3;
    step = fontSize * 4.2;
    for (row = 0, y = -span; y <= span; y += step, row++) {
      for (x = -span - (row % 2) * width / 2; x <= span + width; x += width) ctx.fillText(MARK, x, y);
    }
    ctx.restore();
  }

  function isMunchPage() {
    return !!document.querySelector('.mm-person');
  }

  // Only pictures rebuilt from Maisie's own full-size files (named "...-sharp") are worth
  // magnifying; the older pictures are blown-up screenshots and would only show blur.
  function isSharp(opener) {
    var img = opener.querySelector('img');
    return !!img && /-sharp[._]/.test(img.currentSrc || img.src);
  }

  function hideMagnifier() {
    if (!magnifier) return;
    magnifier.opener = null;
    magnifier.lens.classList.remove('is-visible');
    magnifier.pane.classList.remove('is-visible');
  }

  function startMagnifier(opener) {
    var img = opener.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (!src) return;
    if (!magnifier) {
      var lens = document.createElement('div');
      lens.className = 'mm-magnifier-lens';
      var pane = document.createElement('div');
      pane.className = 'mm-magnifier-pane';
      pane.setAttribute('aria-hidden', 'true');
      pane.innerHTML = '<canvas></canvas>';
      pane.addEventListener('contextmenu', function(e) { e.preventDefault(); });
      document.body.appendChild(pane);
      magnifier = { lens: lens, pane: pane, canvas: pane.querySelector('canvas') };
    }
    var media = opener.querySelector('.product__media') || opener;
    if (magnifier.lens.parentNode !== media) media.appendChild(magnifier.lens);
    var ratio = Math.min(window.devicePixelRatio || 1, 2);
    var shown = img.getBoundingClientRect().width;
    var url = sizedUrl(src, Math.min(4500, Math.round(shown * zoomFor(shown) * ratio)));
    magnifier.opener = opener;
    magnifier.picture = img;
    magnifier.url = url;
    magnifier.img = null;
    loadImage(url).then(function(full) {
      if (magnifier.url === url) magnifier.img = full;
    }).catch(function() {});
  }

  function moveMagnifier(e) {
    var m = magnifier;
    var rect = m.picture.getBoundingClientRect();
    var room = window.innerWidth - rect.right - 40;
    // Beside the picture when there is room (Amazon style); otherwise over the picture itself.
    var inside = room < 280;
    var paneW = Math.round(inside ? rect.width : Math.min(640, room));
    var paneH = Math.round(inside ? rect.height : Math.min(rect.height, window.innerHeight - 40));
    var zoom = zoomFor(rect.width);
    var lensW = Math.min(rect.width, paneW / zoom);
    var lensH = Math.min(rect.height, paneH / zoom);
    var x = Math.max(0, Math.min(e.clientX - rect.left - lensW / 2, rect.width - lensW));
    var y = Math.max(0, Math.min(e.clientY - rect.top - lensH / 2, rect.height - lensH));
    var box = m.lens.parentNode.getBoundingClientRect();

    m.lens.style.width = lensW + 'px';
    m.lens.style.height = lensH + 'px';
    m.lens.style.left = (rect.left - box.left + x) + 'px';
    m.lens.style.top = (rect.top - box.top + y) + 'px';
    m.lens.classList.toggle('is-visible', !inside);

    m.pane.style.width = paneW + 'px';
    m.pane.style.height = paneH + 'px';
    m.pane.style.left = (inside ? rect.left : rect.right + 24) + 'px';
    m.pane.style.top = (inside ? rect.top : Math.max(20, Math.min(rect.top, window.innerHeight - paneH - 20))) + 'px';
    m.pane.classList.toggle('mm-magnifier-pane--inside', inside);
    m.pane.classList.add('is-visible');

    if (!m.img) return; // close-up still loading: the pane shows its plain background
    var ratio = Math.min(window.devicePixelRatio || 1, 2);
    var canvas = m.canvas;
    if (canvas.width !== Math.round(paneW * ratio) || canvas.height !== Math.round(paneH * ratio)) {
      canvas.width = Math.round(paneW * ratio);
      canvas.height = Math.round(paneH * ratio);
      canvas.style.width = paneW + 'px';
      canvas.style.height = paneH + 'px';
    }
    var ctx = canvas.getContext('2d');
    var sx = m.img.naturalWidth / rect.width;
    var sy = m.img.naturalHeight / rect.height;
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(m.img, x * sx, y * sy, lensW * sx, lensH * sy, 0, 0, paneW, paneH);
    lightMark(ctx, paneW, paneH);
  }

  if (canHover) {
    document.addEventListener('mousemove', function(e) {
      var opener = e.target.closest && e.target.closest('.product__modal-opener--image');
      if (!opener || !isMunchPage() || !isSharp(opener)) {
        if (magnifier && magnifier.opener) hideMagnifier();
        return;
      }
      if (!magnifier || magnifier.opener !== opener) startMagnifier(opener);
      if (magnifier && magnifier.opener) moveMagnifier(e);
    }, { passive: true });
    document.addEventListener('click', hideMagnifier, true);
    window.addEventListener('scroll', hideMagnifier, { passive: true });

    // A line under the main picture so people know they can zoom in.
    var hintTries = 0;
    (function addHint() {
      if (!isMunchPage()) {
        if (hintTries++ < 20) setTimeout(addHint, 500);
        return;
      }
      var openers = Array.prototype.slice.call(document.querySelectorAll('.product__modal-opener--image'));
      if (!openers.some(isSharp)) return;
      var opener = openers[0];
      var gallery = opener && (opener.closest('media-gallery') || opener.closest('.product__media-wrapper'));
      if (!gallery || document.querySelector('.mm-magnifier-hint')) return;
      var hint = document.createElement('p');
      hint.className = 'mm-magnifier-hint';
      hint.textContent = 'Hover over the drawing to see the brushstrokes up close. Click to see it larger.';
      gallery.insertAdjacentElement('afterend', hint);
    })();
  }
})();
